import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/27. 알칸소주 벤톤빌 본사.2784eaaebf5cd0630ad6.jpg`;
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/28. 정크브랜즈.bc0780075087ec9a4378.jpg`;
const Factory3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 01.5181a0d1bafde201d211.jpg`;
const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/30. 미국법인 모자.5d5f637cf11e5bcf156f.png`;
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const SalesCorporation2 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation">
                <div className="kor">위탁경영사업장</div>
                <div className="eng">Indirect Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation2">
                <div className="kor">아웃도아 캡 컴퍼니㈜</div>
                <div className="eng">Outdoor Cap Co., Inc.</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">AJM</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation2">
                  <div className="kor">아웃도아 캡 컴퍼니㈜</div>
                  <div className="eng">Outdoor Cap Co., Inc.</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation3">
                  <div className="kor">돌프만밀라노 ㈜</div>
                  <div className="eng">Dorfman Milano Company</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"해외 판매 / 생산 사업장"} titleeng={"Outdoor Cap Co., Inc."} website="https://www.outdoorcap.com/"/>
            <div className="page-text">
              <div className="kor">
                <h2>미국 법인 / Outdoor Cap Co., Inc.</h2>
              </div>
              <div className="eng">
                <h2> U.S.A. company / Outdoor Cap Co., Inc.</h2>
              </div>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">알칸소주 벤톤빌 본사</div>
                <div className="eng">Headquarters in Bentonville, Arkansas</div>
              </div>
            </S.ImgHolderFullsize>

            <S.ImgHolderFlex>
              {/* <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">아웃도어 공장</div>
                  <div className="eng">Outdoor Factory</div>
                </div>
              </S.ImgHolderHarf> */}

              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">정크브랜드</div>
                  <div className="eng">Junk Brands</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>
            {/* <div className="button-right">
              <a className="link-button" href="http://www.junkbrands.com/">
              <div className="kor">@ 바로가기</div>
              <div className="eng">@ Link</div>
                
              </a>
            </div> */}

            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"} />
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>Outdoor Cap Co., Inc. 법인개요</h2></div>
                    <div className="eng"><h2>Company Profile of Outdoor Cap Co., Inc.</h2></div>
                  </div>
                  <div className="kor">
                    법인 설립: 1977년
                    <br />
                    영안 합자: 1989년
                    <br />
                    Junk Brands(정크브랜즈) 인수: 2015년
                  </div>
                  <div className="eng">
                    Establishment : 1977
                    <br />
                    Joint venture with YoungAn : 1989
                    <br />
                    Acquisition of Junk Brands : 2015
                  </div>
                </div>
              </div>
              <div className="kor">
                ※ 알칸소주 벤톤빌 본사
                <br />
                ※ 미국 내 최대 프로모션 모자 판매업체
                <br />
                ※ 월마트 및 다양한 리테일 스토어용 라이센스 모자 판매
                <br />
                ※ 햇밴드 전문 생산/판매업체 정크브랜즈 인수 / 판매 제품 다양화(모자, 의류 및 액세서리)
              </div>
              <div className="eng">
                ※ Headquarters in Bentonville, Arkansas
                <br />
                ※ The largest promotional cap sales company in U.S.A.
                <br />
                ※ Selling licensed caps for Walmart and various retail stores
                <br />
                ※ Acquired Junk Brands(production and sales specialized for 
                <br />
                hat bands) for diversifying sales products(Cap, Apparel and Accessory)
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default SalesCorporation2;
